export interface AppMenuItem {
  name: string;
  path?: string;
  icons: string;
  roles?: string[];
  children?: AppMenuItem[];
}

export const APP_MENUS: AppMenuItem[] = [
  {
    name: 'Dashboard',
    icons: 'bar_chart',
    roles: ['SUPER_ADMIN', 'ADMIN','USER'],
    children: [
      { name: 'User Dashboard', path: '/userdashboard', icons: 'assessment' },
    ],
  },
  {
    name: 'System Configuration',
    icons: 'domain',
    roles: ['SUPER_ADMIN', 'ADMIN'],
    children: [
      {
        name: 'User',
        path: '/createuser',
        icons: 'people',
        roles: ['SUPER_ADMIN','ADMIN'],
        children: [
          {
            name: 'User Registration',
            path: '/createuser',
            icons: 'person_add',
            roles: ['SUPER_ADMIN','ADMIN'],
          },
          {
            name: 'User Management',
            path: '/userlist',
            icons: 'group',
            roles: ['SUPER_ADMIN','ADMIN'],
          },
        ],
      },
      {
        name: 'Services',
        path: '/services',
        icons: 'build',
        roles: ['SUPER_ADMIN', 'ADMIN'],
      },
      {
        name: 'SMS Templates',
        path: '/templates',
        icons: 'message',
        roles: ['SUPER_ADMIN', 'ADMIN'],
      },
      { name: 'Service Template Mapping', 
        path: '/servicetemplatemap', 
        icons: 'link' ,
        roles: ['SUPER_ADMIN', 'ADMIN'],
      },
      {
        name: 'Unit Form',
        path: '/unitmaster',
        icons: 'straighten',
        roles: ['SUPER_ADMIN', 'ADMIN'],
      },
      {
        name: 'Customer Onboarding',
        path: 'createcustomer',
        icons: 'how_to_reg',
        roles: ['SUPER_ADMIN','ADMIN'],
      },
    ],
  },
  {
    name: 'Functionality',
    icons: 'settings_applications',
    roles: ['SUPER_ADMIN', 'ADMIN', 'USER'],
    children: [
      { name: 'Transaction Form', path: 'customertransaction', icons: 'receipt_long' },
      { name: 'Transaction List', path: 'customertransactionlist', icons: 'list_alt' },
      // { name: 'Promotional SMS', path: '/promomsgsetup', icons: 'notifications' },
      { name: 'Scheduled SMS', path: '/smslist', icons: 'schedule' }
    ],
  }
];
